import { useQuery } from '@tanstack/react-query'
import apiV2 from '../../service/apiV2.service'
import { getProductName } from '@dg-util'
import useReactQueryErrorEffect from './useReactQueryErrorEffect'

const useReactQueryDatasource = () => {
  // Get Datasource ProductProps Query
  const productName = getProductName()
  const {
    data: productProps,
    refetch: refetchProductProps,
    isLoading: isGetProductPropsLoading,
    error: getProductPropsError,
  } = useQuery({
    queryKey: ['productProps', productName],
    queryFn: () => apiV2.getDatasourceProductProps(),
    select: (response) => response.data,
  })

  useReactQueryErrorEffect(getProductPropsError)

  // Get Datasource InsuranceCompanies Query
  const {
    data: insuranceCompanies,
    refetch: refetchInsuranceCompanies,
    isLoading: isGetInsuranceCompaniesLoading,
    error: getInsuranceCompaniesError,
  } = useQuery({
    queryKey: ['insuranceCompanies'],
    queryFn: () => apiV2.getDatasourceInsuranceCompanies(),
    select: (response) => response.data,
  })

  useReactQueryErrorEffect(getInsuranceCompaniesError)

  return {
    isLoading: isGetProductPropsLoading || isGetInsuranceCompaniesLoading,
    productProps,
    refetchProductProps,
    insuranceCompanies,
    refetchInsuranceCompanies,
  }
}

export default useReactQueryDatasource
